function feed(data, event) {
    let feedConfig = {
        adlist: [
        ], feedObj: {},data:{},maxnum:0,marginnum:2
    };

    if(isArray(data)){
        feedConfig.adlist = data;
    }else{
        feedConfig.maxnum = data.maxnum;
        feedConfig.adlist = data.list;
    }
    feedConfig.data = {}//信息流辅助数据，用来记录广告id和div
    //pos 位置 showType 展示方式 0 替换 1 插入
    event.on("init", function (data) {
        if (!feedConfig.feedObj.hasOwnProperty(data.tabIndex)) {
            feedConfig.feedObj[data.tabIndex] = {spage: 0};
        }
        insertAd(feedConfig, data.container, data.page, data.tabIndex);
    });
}
function isArray(o) {
    return Object.prototype.toString.call(o) === '[object Array]';
}
//插入广告
function insertAd(feedConfig, el, page, tabIndex) {
    if(el==null) return;
    let aidsObj = {aids: []}, elObj = {};//广告请求对象
    if(feedConfig.feedObj[tabIndex].spage>el.children.length){
        return;
    }
    //灵活处理信息流插入位置，如果内容太少，最后一条插入，内容最后一个位置，其他位置均分，要保证至少1条广告一条内容。
    //至少保证一条数据一条广告
    if(el.children.length<feedConfig.adlist.length) feedConfig.adlist.length= el.children.length;
    let lastItem = feedConfig.adlist[feedConfig.adlist.length-1];
    if(lastItem.pos>el.children.length+feedConfig.adlist.length){
        lastItem.pos =el.children.length+feedConfig.adlist.length;
        let num = 1+Math.floor(el.children.length/feedConfig.adlist.length);
        for(var i=0;i<feedConfig.adlist.length-1;i++){
            feedConfig.adlist[i].pos =Math.min(num*(i+1),feedConfig.adlist[i].pos);
        }
    }
    for (var i = feedConfig.feedObj[tabIndex].spage; i < feedConfig.adlist.length; i++) {
        let item = feedConfig.adlist[i];
        if(el.children.length>=feedConfig.maxnum&&feedConfig.maxnum!=0){
            //当孩子的数量大于设置的总数量，则进行替换
           //item.showType = 0;
            item.pos = Math.min(el.children.length,item.pos)
        }
        if (item.pos > el.children.length + 1) {
            //  feedConfig.feedObj[tabIndex].spage =  el.length;
            item.pos = el.children.length + 1
           break;
        } else {
            //广告位置分为，插入和替换2种方式 showType 展示方式 0 替换 1 插入
            let elDiv;
            if (item.showType == 0) {
                elDiv = el.children[item.pos - 1];
            } else{
                let tagType = el.children[0].tagName;
                elDiv = document.createElement(tagType);
                if(item.pos == el.children.length + 1){
                    elDiv.className = el.children[0].className;
                    el.appendChild(elDiv);
                }else{                   
                    elDiv.className = el.children[0].className;
                    el.insertBefore(elDiv, el.children[item.pos - 1]);
                }
            }
            elDiv.setAttribute("p_" + item.ap, "");
            let adObj = {};
            for (let key in item) {
                if (key != "pos" && key != "showType")
                    adObj[key] = item[key];
            }
            elObj[adObj.ap] = elDiv;
            aidsObj.aids.push(adObj);
        }
    }
    if(el.scrollHeight>el.offsetHeight+20){
        for (let i = 0; i < aidsObj.aids.length; i++) {
            let item = aidsObj.aids[i];
            let {ap} = item;
            let el = elObj[ap];
            IfengAmgr.showPresentAd(el, {aids:[item]}, function (data) {})
        }
    }else{
        let adDataObj = { aids:[]};
        for (let i = 0; i < aidsObj.aids.length;i++) {
            let item = aidsObj.aids[i];
            let { ap, showPresent="0"} = item;
            console.log(ap, item);
            let el = elObj[ap];
            if (showPresent=="1"){
                delete elObj[ap];
                IfengAmgr.showPresentAd(el, { aids: [item] });
            }else{
                adDataObj.aids.push({ ...item });
            }
        }
        if (adDataObj.aids.length>0){
            IfengAmgr.show(elObj, adDataObj);
        }
    }
    feedConfig.feedObj[tabIndex].spage = el.children.length;
}

if (typeof  window.IfengAmgr != undefined) {
    window.IfengAmgr.tplLib.feed_c = {render: feed, version: "1.0.0"};
}